import React, { useMemo } from 'react'
import { SelectList } from '../select-list/select-list'
import { IconRole } from '../../../../../../../shared/icon/icon'
import { roleLabel, useAddUserContext } from '../context'
import { IconButtonClick } from '../../../../../../../shared/icon/icon-button-click'
import { useButtonCount } from './hooks'

// Auto roles (every member gets them) read "Always included"; roles picked for
// the whole batch are readonly on each row too and say so.
export const roleReadonlyHint = role => (role && role.isAutoUser ? 'Always included' : 'Added for everyone')

export const SelectRoleDropdown = ({ selectedRoles, readonlyRoles, disabled, onClick }) => {
  const count = useButtonCount(selectedRoles, readonlyRoles)
  const text = useMemo(() => (count ? `roles (${count})` : 'roles'), [count])
  return (
    <button className="dropdown-item" disabled={disabled} onClick={onClick}>
      <span className="me-1">
        <IconRole />
      </span>
      <span>
        {text}
      </span>
    </button>
  )
}

export const SelectRoleButton = ({ selectedRoles, readonlyRoles, small, disabled, onClick }) => {
  const count = useButtonCount(selectedRoles, readonlyRoles)
  const text = useMemo(() => (count ? `roles (${count})` : 'roles'), [count])
  return <IconButtonClick Icon={IconRole} text={text} disabled={disabled} small={small} onClick={onClick} />
}

export const SelectRoleModal = ({ target, selectedRoles, readonlyRoles, onUpdate, onHide }) => {
  const addUserContext = useAddUserContext()

  const handleClose = () => onHide()

  const onAdd = item => {
    let newList = [...selectedRoles, item]
    onUpdate(newList)
  }

  const onRemove = item => {
    let newList = selectedRoles.filter(i => i.id !== item.id)
    onUpdate(newList)
  }

  return (
    <React.Fragment>
      <SelectList
        header="Roles"
        selectedItems={selectedRoles}
        readonlyItems={readonlyRoles}
        items={addUserContext.allRoles}
        modalTarget={target}
        fnTagFormat={roleLabel}
        fnListFormat={roleLabel}
        readonlyHint={roleReadonlyHint}
        fnListFilter={(filter, items) => items.filter(i => roleLabel(i).toLowerCase().includes(filter.toLowerCase()))}
        onAdd={onAdd}
        onRemove={onRemove}
        onClose={handleClose}
      />
    </React.Fragment>
  )
}
